// components/Points/PointLogItem.jsx

import React from 'react';
import { ListItem, ListItemText, Divider } from '@mui/material';

const PointLogItem = ({ log }) => {
    return (
        <>
            <ListItem>
                <ListItemText
                    primary={`${log.point_type} ${log.amount > 0 ? '+' : ''}${log.amount}pt`}
                    secondary={`${log.description || '상세 설명 없음'} [${log.date}]`}
                />
            </ListItem>
            <Divider />
        </>
    );
};

export default PointLogItem;
